/*
 * Renderiza el TimeRecordModal fuera del arbol React principal.
 * Crea un div temporal, monta un root independiente con Apollo e i18n,
 * y lo limpia al cerrar el modal.
 */
import { createRoot } from 'react-dom/client'
import { ApolloProvider, ApolloClient } from '@apollo/client'
import { I18nextProvider } from 'react-i18next'
import TimeRecordModal from './timeRecordModal'
import i18n from '../../../utils/i18nextInit'

export const openTimeRecordModal = (client: ApolloClient<any>) => {
  const container = document.createElement('div')
  document.body.appendChild(container)

  const root = createRoot(container)

  const handleClose = () => {
    root.unmount()
    document.body.removeChild(container)
  }

  root.render(
    <ApolloProvider client={client}>
      <I18nextProvider i18n={i18n}>
        <TimeRecordModal onClose={handleClose} />
      </I18nextProvider>
    </ApolloProvider>
  )
}
